export default __webpack_public_path__ + "static/assets/6d971205e4e09bbc704e3ea09bae1126.jpg";